import { Routes } from '@angular/router';
import { MobileMessageComponent } from './message/mobile_message.component';

export const mobileRoutes: Routes = [

    {path: '', component: MobileMessageComponent},
];
